// extracted by mini-css-extract-plugin
export default {"footerImage":"footer_footerImage__J1EaP","socials":"footer_socials__t5k4+","socialIcon":"footer_socialIcon__cNh4k","socialLink":"footer_socialLink__kbW7e"};